import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Field, reduxForm } from 'redux-form';

import { updateProfile } from '../../../actions/userActions';
import { trimUserInput } from '../../../utils/formHelpers';

import Alert from '../../alerts/Alert/Alert';

import './UpdateUserProfileForm.css';

const validate = formProps => {
  const errors = {};

  if (!formProps.firstname) {
    errors.firstname = 'Required';
  } else if (formProps.firstname.length > 20) {
    errors.firstname = 'Must be 20 characters or less';
  }

  if (!formProps.lastname) {
    errors.lastname = 'Required';
  } else if (formProps.lastname.length > 20) {
    errors.lastname = 'Must be 20 characters or less';
  }

  // if ( !formProps.email ) {
  //   errors.email = 'Required'
  // }
  // else if ( !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(formProps.email) ) {
  //   errors.email = 'Invalid email address'
  // }

  if (!formProps.skypeId) {
    errors.skypeId = 'Skype ID is required';
  } else if (formProps.skypeId.length < 4) {
    errors.skypeId = 'Must be 4 characters or more';
  }

  return errors;
};

const renderField = ({
  input,
  label,
  type,
  placeholder,
  disabled,
  meta: { touched, error, warning }
}) => {
  let hasStatus = null;
  let message = null;

  // remove touched from first two tests to
  // force form validation on initial load
  // if ( touched && error ) {
  if (error) {
    hasStatus = 'danger';
    message = error;
  } else if (warning) {
    // else if ( touched && warning ) {
    hasStatus = 'warning';
    message = warning;
  } else if (touched) {
    hasStatus = 'success';
    message = null;
  } else {
    hasStatus = null;
    message = null;
  }

  return (
    <div className={`form-group row ${hasStatus ? 'has-' + hasStatus : ''}`}>
      <label className="col-form-label col-sm-3 text-sm-right pr-0" htmlFor={input.name}>
        {label}
      </label>

      <div className="col-sm-9">
        <input
          id={input.name}
          className="form-control form-control-danger form-control-warning form-control-success"
          {...input}
          disabled={disabled}
          placeholder={placeholder}
          type={type}
        />

        {message ? <div className="form-control-feedback"> {message} </div> : ''}
      </div>
    </div>
  );
};

class UpdateUserProfileForm extends Component {
  handleFormSubmit = (values) => {
    return new Promise((resolve, reject) => {
      const userInput = trimUserInput(values);
      const { firstname, lastname, skypeId } = userInput;
      const { updateProfile, handleProfileUpdateSuccess } = this.props;
      updateProfile({
        givenName: firstname,
        familyName: lastname,
        skypeName: skypeId
      }, false, () => {
        handleProfileUpdateSuccess();
        resolve();
      }, error => {
        reject(error);
      });
    });
  }

  renderFormError(error) {
    return (
      <Alert className="UpdateUserProfileFormError mb-4" alertType="danger">
        {// if the error is a string, return it,
        // otherwise build the error message
          typeof error === 'string' ? error : `${error.status}: ${error.statusText}`
        }
      </Alert>
    );
  }

  render() {
    const {
      error, handleSubmit, pristine, reset, submitting
    } = this.props;

    return (
      <form className="UpdateUserProfileForm form" onSubmit={handleSubmit(this.handleFormSubmit)}>
        {// if an error exists, render an Alert
          error && this.renderFormError(error)
        }

        <Field
          name="firstname"
          component={renderField}
          type="text"
          label="First Name"
          placeholder="First name"
        />

        <Field
          name="lastname"
          type="text"
          component={renderField}
          label="Last Name"
          placeholder="Last name"
        />

        <Field
          name="email"
          disabled
          component={renderField}
          type="email"
          label="Email"
          placeholder="Email"
        />

        <Field
          name="skypeId"
          component={renderField}
          type="text"
          label="Skype ID"
          placeholder="Skype ID"
        />

        {/* <Field name="country" */}
        {/* component={ renderField } */}
        {/* type="text" */}
        {/* label="Country" */}
        {/* placeholder="Country" /> */}

        <div className="form-group row">
          <div className="col-sm offset-sm-3">
            <button
              type="button"
              className="btn btn-secondary mr-1"
              disabled={pristine || submitting}
              onClick={reset}
            >
              Reset
            </button>

            <button type="submit" className="btn btn-primary" disabled={pristine || submitting}>
              Save
            </button>
          </div>
        </div>
      </form>
    );
  }
}

function mapStateToProps(state) {
  return {
    initialValues: {
      id: state.user.id,
      firstname: state.user.profile.givenName,
      lastname: state.user.profile.familyName,
      email: state.user.profile.email,
      skypeId: state.user.profile.skypeName
    },
    error: state.user.error
  };
}

export default connect(
  mapStateToProps,
  { updateProfile }
)(
  reduxForm({ form: 'updateUserProfileForm', validate })(UpdateUserProfileForm)
);



// WEBPACK FOOTER //
// ./src/components/forms/UserProfileForm/UpdateUserProfileForm.js